module.exports = __webpack_public_path__ + "h5/img/home12.ac1d2cf8.png";